// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3S6_M","rootMobile":"styles_rootMobile__2PLSx"};